/* MT/26 — cart page + cart drawer. Ajax cart API + Section Rendering API. Depends on mt-base.js (MT.money, MT.init). */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function q(s, sc) { return (sc || document).querySelector(s); }
  function qa(s, sc) { return Array.prototype.slice.call((sc || document).querySelectorAll(s)); }
  function money(c) { return (window.MT && MT.money) ? MT.money(c) : '$' + (c / 100).toFixed(2); }
  function initMT(scope) { if (window.MT && MT.init) MT.init(scope); }
  var pageSection = q('[data-mt-cart]');
  var drawer = q('[data-mt-cart-drawer]');
  var shade = q('.mt-cd-shade');
  var sectionIds = [];
  if (pageSection) sectionIds.push(pageSection.dataset.sectionId);
  if (drawer) sectionIds.push(drawer.dataset.sectionId);

  /* ---------- cart API ---------- */
  function api(path, body) {
    return fetch(root + 'cart/' + path + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(Object.assign({}, body, { sections: sectionIds.join(','), sections_url: location.pathname }))
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function rerender(sections) {
    if (!sections) return;
    [pageSection, drawer].forEach(function (sec) {
      if (!sec) return;
      var html = sections[sec.dataset.sectionId];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = sec === drawer ? q('[data-mt-cart-drawer]', doc) : q('[data-mt-cart]', doc);
      if (!fresh) return;
      // keep drawer open state + scroll position; keep toggles
      var scroll = q('[data-mt-cd-scroll]', sec); var scrollTop = scroll ? scroll.scrollTop : 0;
      var codeOpen = q('[data-mt-code-toggle]', sec) && q('[data-mt-code-toggle]', sec).getAttribute('aria-expanded') === 'true';
      var noteOpen = q('[data-mt-note-toggle]', sec) && q('[data-mt-note-toggle]', sec).getAttribute('aria-expanded') === 'true';
      var toastHidden = q('[data-mt-cd-toast]', sec) ? q('[data-mt-cd-toast]', sec).hidden : true;
      var toastText = q('[data-mt-cd-toast-text]', sec) ? q('[data-mt-cd-toast-text]', sec).textContent : '';
      var wasOpen = sec.classList.contains('mt-open');
      sec.innerHTML = fresh.innerHTML;
      if (wasOpen) sec.classList.add('mt-open');
      var s2 = q('[data-mt-cd-scroll]', sec); if (s2) s2.scrollTop = scrollTop;
      if (codeOpen) setToggle(q('[data-mt-code]', sec), true);
      if (noteOpen) setToggle(q('[data-mt-note]', sec), true);
      var t = q('[data-mt-cd-toast]', sec); if (t && !toastHidden) { t.hidden = false; q('[data-mt-cd-toast-text]', t).textContent = toastText; }
      initMT(sec); loadUpsells(sec); renderAppliedCode(sec);
    });
    // header cart count (Symmetry + ours)
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      qa('.cart-count, .header__cart-count, [data-mt-header-count], .js-cart-count').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      document.dispatchEvent(new CustomEvent('mt:cart:updated', { detail: cart }));
    });
  }
  function busy(on) { qa('[data-mt-lines]').forEach(function (l) { l.classList.toggle('mt-busy', on); }); }
  function change(body) { busy(true); return api('change', body).then(function (j) { rerender(j.sections); return j; }).catch(function (e) { busy(false); toast(e && e.description || 'Could not update cart', true); throw e; }); }
  function add(items, opts) {
    opts = opts || {};
    return api('add', { items: items }).then(function (j) {
      rerender(j.sections);
      var title = j.items && j.items[0] ? j.items[0].product_title : (j.product_title || '');
      if (drawer && drawer.dataset.openOnAdd !== 'false' && !opts.silent) { openDrawer(); toast('Added to cart — ' + title); }
      return j;
    }).catch(function (e) { toast(e && e.description || 'Could not add to cart', true); throw e; });
  }
  function toast(text, isErr) {
    var t = drawer && q('[data-mt-cd-toast]', drawer); if (!t) return;
    q('[data-mt-cd-toast-text]', t).textContent = text; t.hidden = false; t.style.background = isErr ? '#BF570A' : '';
    clearTimeout(t._h); t._h = setTimeout(function () { t.hidden = true; }, 3500);
  }

  /* ---------- drawer open/close ---------- */
  var lastFocus;
  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('mt-open'); if (shade) shade.classList.add('mt-open'); document.body.classList.add('mt-cd-locked');
    setTimeout(function () { drawer.focus(); }, 50);
    loadUpsells(drawer);
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('mt-open'); if (shade) shade.classList.remove('mt-open'); document.body.classList.remove('mt-cd-locked');
    var t = q('[data-mt-cd-toast]', drawer); if (t) t.hidden = true;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function refreshDrawer() {
    if (!drawer) return Promise.resolve();
    return fetch(location.pathname + '?section_id=' + drawer.dataset.sectionId).then(function (r) { return r.text(); }).then(function (html) { var o = {}; o[drawer.dataset.sectionId] = html; rerender(o); });
  }
  window.MT = window.MT || {};
  MT.openCart = function () { refreshDrawer().then(openDrawer); };
  MT.closeCart = closeDrawer;
  MT.cartAdd = add;
  // theme + app hooks
  document.addEventListener('on:cart:add', function () { if (drawer && drawer.dataset.openOnAdd !== 'false') MT.openCart(); });
  document.addEventListener('dispatch-cart-drawer:open', MT.openCart);
  document.addEventListener('dispatch:cart-drawer:open', MT.openCart);
  document.addEventListener('dispatch:cart-drawer:refresh', function () { if (pageSection) refreshAll(); else refreshDrawer(); });   /* promo engine applies a ladder code: on /cart re-render the page summary too */
  document.addEventListener('dispatch:cart-drawer:close', closeDrawer);
  document.addEventListener('mt:open-cart', MT.openCart);
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href$="/cart"], a[href="' + root + 'cart"], [data-mt-cart-open], .js-cart-drawer-open, .header__cart-link, a.cart-link');
    if (a && drawer && !e.target.closest('[data-mt-cart]') && !a.closest('.mt-cd')) { e.preventDefault(); MT.openCart(); }
    if (e.target.closest('[data-mt-cd-close]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && drawer.classList.contains('mt-open')) closeDrawer(); });
  // swipe down to close (mobile sheet)
  if (drawer) {
    var y0 = null;
    drawer.addEventListener('touchstart', function (e) { var sc = q('[data-mt-cd-scroll]', drawer); if (!sc || sc.scrollTop <= 0) y0 = e.touches[0].clientY; }, { passive: true });
    drawer.addEventListener('touchmove', function (e) { if (y0 !== null && e.touches[0].clientY - y0 > 90) { y0 = null; closeDrawer(); } }, { passive: true });
    drawer.addEventListener('touchend', function () { y0 = null; });
  }

  /* ---------- line actions (delegated; works after rerender) ---------- */
  var qtyTimer = {};
  document.addEventListener('click', function (e) {
    var line = e.target.closest('[data-mt-line]'); var key = line && line.dataset.key;
    var minus = e.target.closest('[data-mt-qty-minus]'), plus = e.target.closest('[data-mt-qty-plus]');
    if (line && (minus || plus)) {
      var inp = q('[data-mt-qty-input]', line); var v = Math.max(0, (parseInt(inp.value, 10) || 0) + (plus ? 1 : -1));
      inp.value = v; scheduleQty(line, key, v); return;
    }
    if (line && e.target.closest('[data-mt-remove]')) { line.classList.add('mt-removing'); setTimeout(function () { change({ id: key, quantity: 0 }); }, 250); return; }
    var st = e.target.closest('[data-mt-size-toggle]');
    if (line && st) { var sizes = q('[data-mt-sizes]', line); var cta = q('[data-mt-size-cta]', line); sizes.hidden = !sizes.hidden; if (cta) cta.textContent = sizes.hidden ? 'Change size' : 'Close'; return; }
    var pick = e.target.closest('[data-mt-size-pick]');
    if (line && pick) {
      var newId = parseInt(pick.dataset.mtSizePick, 10), qty = parseInt(q('[data-mt-qty-input]', line).value, 10) || 1;
      var oldId = parseInt(line.dataset.variantId, 10);
      var props = {}; try { props = JSON.parse(line.dataset.props || '{}') || {}; } catch (e0) {}
      // optimistic UI: show the new size right away, collapse the picker
      var lbl = q('.mt-cl__variant > span', line); if (lbl) lbl.textContent = lbl.textContent.replace(/[^·]*$/, ' ' + pick.textContent.trim()).replace(/^\s+/, '');
      qa('.mt-cl__size', line).forEach(function (b) { b.classList.toggle('mt-on', b === pick); });
      var sizesEl = q('[data-mt-sizes]', line); if (sizesEl) sizesEl.hidden = true; var ctaEl = q('[data-mt-size-cta]', line); if (ctaEl) ctaEl.textContent = 'Change size';
      line.classList.add('mt-busy');
      var swap;
      if (Object.keys(props).length) {
        swap = api('change', { id: key, quantity: 0 }).then(function () { return api('add', { items: [{ id: newId, quantity: qty, properties: props }] }); });
      } else {
        var updates = {}; updates[oldId] = 0; updates[newId] = qty;
        swap = api('update', { updates: updates });
      }
      swap.then(function (j2) { rerender(j2.sections); toast('Size updated'); }).catch(function (e2) { line.classList.remove('mt-busy'); toast(e2 && e2.description || 'Could not change size', true); refreshAll(); });
      return;
    }
    var up = e.target.closest('[data-mt-upsell-add]');
    if (up) { up.classList.add('mt-loading'); add([{ id: parseInt(up.dataset.mtUpsellAdd, 10), quantity: 1 }], { silent: !!e.target.closest('.mt-cd') }).then(function () { up.classList.remove('mt-loading'); }).catch(function () { up.classList.remove('mt-loading'); }); return; }
    var ct = e.target.closest('[data-mt-code-toggle]'); if (ct) { setToggle(ct.closest('[data-mt-code]'), ct.getAttribute('aria-expanded') !== 'true'); return; }
    var nt = e.target.closest('[data-mt-note-toggle]'); if (nt) { setToggle(nt.closest('[data-mt-note]'), nt.getAttribute('aria-expanded') !== 'true'); return; }
    var ap = e.target.closest('[data-mt-code-apply]'); if (ap) { applyCode(ap.closest('[data-mt-code]')); return; }
    var rc = e.target.closest('[data-mt-code-remove]'); if (rc) { removeCode(rc.closest('[data-mt-code]'), rc.dataset.mtCodeRemove); return; }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-mt-qty-input]')) { var line = e.target.closest('[data-mt-line]'); scheduleQty(line, line.dataset.key, Math.max(0, parseInt(e.target.value, 10) || 0)); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.matches('[data-mt-code-input]')) { e.preventDefault(); applyCode(e.target.closest('[data-mt-code]')); } });
  function scheduleQty(line, key, v) { clearTimeout(qtyTimer[key]); line.classList.add('mt-busy'); qtyTimer[key] = setTimeout(function () { change({ id: key, quantity: v }); }, 220); }
  function setToggle(wrap, open) {
    if (!wrap) return;
    var btn = q('[aria-expanded]', wrap), body = q('.mt-code__body, .mt-note__body', wrap);
    btn.setAttribute('aria-expanded', open); body.hidden = !open; var i = q('i', btn); if (i) i.textContent = open ? '−' : '+';
    if (open) { var inp = q('input, textarea', body); if (inp) setTimeout(function () { inp.focus(); }, 30); }
  }

  /* ---------- order note (autosave) ---------- */
  var noteTimer;
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-mt-note-input]')) return;
    var wrap = e.target.closest('[data-mt-note]'); var len = q('[data-mt-note-len]', wrap); if (len) len.textContent = e.target.value.length;
    var saved = q('[data-mt-note-saved]', wrap); if (saved) saved.hidden = true;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: e.target.value }) }).then(function () { if (saved) saved.hidden = false; });
    }, 700);
  });

  /* ---------- discount code (Shopify /discount/CODE → applies to checkout; validated by comparing cart totals) ---------- */
  function applyCode(wrap) {
    var inp = q('[data-mt-code-input]', wrap), btn = q('[data-mt-code-apply]', wrap), err = q('[data-mt-code-err]', wrap), field = q('.mt-code__field', wrap);
    var code = (inp.value || '').trim().toUpperCase(); if (!code) return;
    btn.classList.add('mt-loading'); err.hidden = true; field.classList.remove('mt-err');
    fetch(root + 'discount/' + encodeURIComponent(code) + '?redirect=/cart', { credentials: 'same-origin' })
      .then(function () { return fetch(root + 'cart.js'); }).then(function (r) { return r.json(); })
      .then(function (cart) {
        var applied = (cart.cart_level_discount_applications || []).some(function (d) { return d.title.toUpperCase() === code; }) || cart.items.some(function (i) { return (i.line_level_discount_allocations || []).some(function (a) { return a.discount_application.title.toUpperCase() === code; }); });
        btn.classList.remove('mt-loading');
        if (applied) { inp.value = ''; storeCode(code); refreshAll(); }
        else {
          // code accepted by Shopify only at checkout (e.g. shipping / customer-specific) — keep it, mark pending
          storeCode(code, true); inp.value = ''; renderAppliedCode(wrap.closest('[data-mt-cart], [data-mt-cart-drawer]') || document);
        }
      }).catch(function () { btn.classList.remove('mt-loading'); err.hidden = false; field.classList.add('mt-err'); });
  }
  function removeCode(wrap, code) {
    var list = getCodes().filter(function (c) { return c.code !== code; }); localStorage.setItem('mt-codes', JSON.stringify(list));
    fetch(root + 'discount/clear?redirect=/cart', { credentials: 'same-origin' }).then(refreshAll);
  }
  function getCodes() { try { return JSON.parse(localStorage.getItem('mt-codes') || '[]'); } catch (e) { return []; } }
  function storeCode(code, pending) { var list = getCodes().filter(function (c) { return c.code !== code; }); list.push({ code: code, pending: !!pending }); localStorage.setItem('mt-codes', JSON.stringify(list)); }
  function renderAppliedCode(scope) {
    qa('[data-mt-code]', scope).forEach(function (wrap) {
      var box = q('[data-mt-code-applied]', wrap); if (!box) return;
      var codes = getCodes(); box.innerHTML = ''; box.hidden = codes.length === 0;
      codes.forEach(function (c) {
        var d = document.createElement('div'); d.className = 'mt-code__chip';
        d.innerHTML = '<span><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>' + c.code + (c.pending ? ' · applied at checkout' : '') + '</span><button type="button" data-mt-code-remove="' + c.code + '" aria-label="Remove code"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
        box.appendChild(d);
      });
      if (codes.length) setToggle(wrap, true);
    });
  }
  function refreshAll() {
    var url = location.pathname + '?sections=' + sectionIds.join(',');
    return fetch(url).then(function (r) { return r.json(); }).then(rerender);
  }

  /* ---------- upsells: complementary recs for the first two cart products, matched to the size/colour in the cart ---------- */
  function cartProfile(scope) {
    var lines = qa('[data-mt-line]', scope.closest ? (scope.closest('[data-mt-cart], [data-mt-cart-drawer]') || scope) : scope);
    if (!lines.length) lines = qa('[data-mt-line]');
    var prof = { size: null, color: null, ids: [] };
    lines.forEach(function (l) {
      try {
        var names = JSON.parse(l.dataset.options || '[]'), opts = JSON.parse(l.dataset.opts || '[]');
        names.forEach(function (n, i) { var k = String(n).toLowerCase(); if (k === 'size' && !prof.size) prof.size = opts[i]; if (/colou?r/.test(k) && !prof.color) prof.color = opts[i]; });
      } catch (e) {}
      if (l.dataset.productId && prof.ids.indexOf(l.dataset.productId) === -1) prof.ids.push(l.dataset.productId);
    });
    return prof;
  }
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function matchUpsells(el) {
    var prof = cartProfile(el), grid = q('[data-mt-upsell-grid]', el); if (!grid) return;
    var matched = 0, total = 0;
    qa('[data-mt-upsell-card]', grid).forEach(function (card) {
      var names, vars; try { names = JSON.parse(card.dataset.options || '[]'); vars = JSON.parse(card.dataset.variants || '[]'); } catch (e) { return; }
      total++;
      if (prof.ids.indexOf(card.dataset.productId) !== -1) { card.hidden = true; return; }
      var si = -1, ci = -1; names.forEach(function (n, i) { var k = String(n).toLowerCase(); if (k === 'size') si = i; if (/colou?r/.test(k)) ci = i; });
      var pick = null, sizeOk = false;
      if (si > -1 && prof.size) {
        var bySize = vars.filter(function (v) { return v.available && norm(v.opts[si]) === norm(prof.size); });
        if (bySize.length) { sizeOk = true; pick = bySize.find(function (v) { return ci > -1 && prof.color && norm(v.opts[ci]) === norm(prof.color); }) || bySize[0]; }
      }
      if (!pick) pick = vars.find(function (v) { return v.available; }) || vars[0];
      if (!pick) { card.hidden = true; return; }
      var btn = q('[data-mt-upsell-add]', card); if (btn) btn.dataset.mtUpsellAdd = pick.id;
      var pr = q('[data-mt-upsell-price]', card); if (pr) pr.textContent = money(pick.price);
      var vl = q('[data-mt-upsell-variant]', card);
      if (vl) { vl.textContent = names.length && pick.title !== 'Default Title' ? pick.title : 'One size'; if (sizeOk) { vl.insertAdjacentHTML('afterbegin', '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>'); } }
      card.classList.toggle('mt-upsell--matched', sizeOk);
      if (sizeOk) { matched++; grid.insertBefore(card, grid.firstChild); }
    });
    var sub = q('[data-mt-upsell-sub]', el);
    if (sub) sub.textContent = prof.size ? 'Picked to match your cart · size ' + prof.size + (prof.color ? ', ' + prof.color : '') : '';
    var visible = qa('[data-mt-upsell-card]:not([hidden])', grid).length;
    if (!visible) el.hidden = true; else el.hidden = false;
    var nav = q('.mt-upsell-nav', el); if (nav) nav.hidden = visible < 2;
  }
  function loadUpsells(scope) {
    qa('[data-mt-upsell]', scope).forEach(function (el) {
      if (el.dataset.loaded || !el.dataset.url || el.dataset.url.indexOf('product_id=&') > -1) { if (!el.dataset.loaded) matchUpsells(el); return; }
      el.dataset.loaded = '1';
      var prof = cartProfile(el), mine = q('[data-mt-upsell-grid]', el);
      var urls = prof.ids.slice(0, 2).map(function (id) { return el.dataset.url.replace(/product_id=\d*/, 'product_id=' + id); });
      if (!urls.length) urls = [el.dataset.url];
      Promise.all(urls.map(function (u) { return fetch(u).then(function (r) { return r.text(); }).catch(function () { return ''; }); })).then(function (htmls) {
        var seen = {}, cards = [];
        htmls.forEach(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          qa('[data-mt-upsell-card]', doc).forEach(function (c) { var id = c.dataset.productId; if (!seen[id]) { seen[id] = 1; cards.push(c); } });
        });
        if (cards.length && mine) { mine.innerHTML = ''; cards.forEach(function (c) { mine.appendChild(c); }); initMT(mine); }
        matchUpsells(el);
      });
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mt-upsell-prev], [data-mt-upsell-next]'); if (!b) return;
    var el = b.closest('[data-mt-upsell]'), grid = el && q('[data-mt-upsell-grid]', el); if (!grid) return;
    var card = q('[data-mt-upsell-card]:not([hidden])', grid); var step = card ? card.getBoundingClientRect().width + 12 : 300;
    grid.scrollBy({ left: b.hasAttribute('data-mt-upsell-next') ? step : -step, behavior: 'smooth' });
  });

  /* ---------- boot ---------- */
  function boot() {
    renderAppliedCode(document); loadUpsells(document);
    if (drawer && drawer.parentNode !== document.body) document.body.appendChild(drawer.previousElementSibling && drawer.previousElementSibling.classList.contains('mt-cd-shade') ? drawer.previousElementSibling : shade || document.createElement('span'));
    if (drawer && drawer.parentNode !== document.body) document.body.appendChild(drawer);
    if (drawer && drawer.dataset.mtAutoopen) MT.openCart();
    // Shopify theme editor: open drawer when its section is selected
    document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(drawer)) openDrawer(); });
    document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(drawer)) closeDrawer(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
